/* eslint-disable no-underscore-dangle */
import {combineReducers} from "redux";

import {storeApi} from "@atg-horse-shared/store-api";
import {
    modalsReducer as modals,
    modalDataReducer as modalData,
} from "@atg-shared/modals-data-access";
import {memberCustomizationReducer as memberCustomization} from "@atg-tillsammans/app-data-access/redux";
import bet from "@atg-tillsammans/bet-data-access/common/redux/betReducer";
import game from "@atg-tillsammans/game-data-access/common/redux/gameReducer";
import {roundReducer as round} from "@atg-tillsammans/round-data-access";
import {teamChatReducer as chat} from "@atg-tillsammans/team-chat-data-access";
import {inviteReducer as invite} from "@atg-tillsammans/team-data-access/redux/invite";
import {teamsReducer as teams} from "@atg-tillsammans/team-data-access/redux/team";
import {teamMemberReducer as teamMember} from "@atg-tillsammans/team-member-data-access";
import {jackpotReducer as jackpot} from "@atg-tillsammans-shared/jackpot-data-access";
import {personalizationReducer as personalization} from "@atg-tillsammans-shared/personalization-data-access";
import {sagaFlowReducer as sagaFlow} from "@atg-tillsammans-shared/saga-flow";
import {sharedBetReducer as sharedBet} from "@atg-tillsammans-shared/shared-bet-data-access";

const createRootReducer = () =>
    combineReducers({
        [storeApi.reducerPath]: storeApi.reducer,
        memberCustomization,
        teams,
        teamMember,
        jackpot,
        game,
        bet,
        personalization,
        mainMenu: () => window._frameStore.getState().mainMenu,
        modals,
        modalData,
        chat,
        sagaFlow,
        invite,
        round,
        sharedBet,
        alert: () => window._frameStore.getState().alert,
        unAuthorizedLogin: () => window._frameStore.getState().unAuthorizedLogin,
        auth: () => window._frameStore.getState().auth,
        accessToken: () => window._frameStore.getState().accessToken,
        router: () => window._frameStore.getState().router,
        user: () => window._frameStore.getState().user,
        limits: () => window._frameStore.getState().limits,
        toasts: () => window._frameStore.getState().toasts,
        mainNavbar: () => window._frameStore.getState().mainNavbar,
    });

export default createRootReducer;
